module.exports = function () {
    $('.js-products-carousel').on('init', function (event, slick) {
        $(this).removeClass('row')
            .closest('.s-slick')
            .removeClass('c-recommendation--slick-uninitialized')
            .find('.st-product-grid__item')
            .removeClass('col-6 col-md-3');
    });

    // Set tech icons as unfocusable when slide not active
    $('.js-products-carousel').on('init afterChange', function () {
        $('.slick-slide[aria-hidden=true]').find('.c-product-tile__tech-icons__icon').attr('tabindex', '-1');
    });

    $('.js-products-carousel:not(.slick-initialized)').slick({
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 544,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.js-family-carousel').on('init', function (event, slick) {
        $(this).removeClass('row')
            .closest('.s-slick')
            .removeClass('st-product-detail__product-families--slick-uninitialized')
            .find('.st-product-detail__carousel-item')
            .removeClass('col-12 col-md-4');
    });

    $('.js-family-carousel').slick({
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 544,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.js-has-carousel-tab').on('focus click collapsible:toggleVisibility', function () {
        $('.js-products-carousel').slick('refresh');
    });

    $(document).on('click', '.c-product-promo__details-link', function () {
        $(this).addClass('details-link-active');
    });
    $(document).on('click', '#contentModal .close', function () {
        $('.details-link-active').trigger('focus');
        $('.c-product-promo__details-link').removeClass('details-link-active');
    });
    $(document).on('click', '.js-bv-ratings-see-all', function() {
        $('html, body').animate({ scrollTop: $('#bv_review_maincontainer').offset().top }, 1000);
    });
};
